import RouteTemplate from 'ember-route-template';
import UiPage from 'garaje/components/ui/page';

export default RouteTemplate(
  <template>
    <UiPage>
      {{outlet}}
    </UiPage>
  </template>,
);
